import { IOrganization } from 'app/shared/model/organization.model';

export interface IOrganizationConfiguration {
  id?: number;
  apiKey?: string | null;
  apiSecret?: string | null;
  callbackUrl?: string | null;
  organization?: IOrganization | null;
}

export const defaultValue: Readonly<IOrganizationConfiguration> = {};
